import React from 'react'

import { TagComponent } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import {
  func, string, number, oneOfType,
} from 'prop-types'

function RefundedTag({ refundId, onOpenRefund, label }) {
  return (
    <TagComponent
      color="warning"
      type="secondary"
      small
      onTagClick={() => onOpenRefund([refundId])}
    >
      {label}
    </TagComponent>
  )
}

RefundedTag.propTypes = {
  refundId: oneOfType([string, number]).isRequired,
  onOpenRefund: func.isRequired,
  label: string.isRequired,
}

export default RefundedTag
